export enum Strings {
  DOUBLE_DASH = '--',
}
